import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Empiezas a tejer… pero abandonas porque no entiendes los patrones', 'Pasas horas buscando tutoriales y terminas más confundida', 'Sientes que esto no es para ti, aunque te encanta', 'Ves cosas hermosas en Pinterest pero no sabes cómo hacerlas'];
  return <section className="w-full py-16 px-4 bg-white" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-center text-gray-900 mb-12" data-id="element-98">
          ¿Te pasa esto?
        </h2>

        <div className="space-y-4 mb-8" data-id="element-99">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-4 p-4 bg-red-50 border-l-4 border-urgency rounded-r-lg" data-id="element-100">
              <XCircleIcon className="w-6 h-6 text-urgency flex-shrink-0 mt-1" aria-hidden="true" data-id="element-101" />
              <p className="font-body text-lg text-gray-800" data-id="element-102">{problem}</p>
            </div>)}
        </div>

        <div className="text-center mt-12 p-6 bg-gray-50 rounded-2xl" data-id="element-103">
          <p className="font-body text-xl md:text-2xl text-gray-900 font-semibold" data-id="element-104">
            👉 No es tu culpa…
          </p>
          <p className="font-body text-lg text-gray-700 mt-2" data-id="element-105">
            El problema es que nadie te enseñó de forma simple.
          </p>
        </div>
      </div>
    </section>;
}